import { render, staticRenderFns } from "./BalanceExtract.vue?vue&type=template&id=f4b1da4e"
import script from "./BalanceExtract.vue?vue&type=script&lang=js"
export * from "./BalanceExtract.vue?vue&type=script&lang=js"
import style0 from "./BalanceExtract.vue?vue&type=style&index=0&id=f4b1da4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports